export default __webpack_public_path__ + "static/media/1.ce0363e1.svg";